<template>
  <!-- 面包屑 -->
  <div class="tab-path">
    <div style="width: 20px"></div>
    <div class="path ubw">
      <div v-for="(path, index) in [...(menuObj[parentPath] || []), ...(menuObj[currentPath] || [])]" :key="index">
        <!-- /admin/dashboard特殊处理 -->
        <span class="gap" v-if="index &&currentPath!=='/admin/dashboard'">/</span>
        <span class="title link" @click="jump(path.loadRes)" v-if="index && index + 1 < [...(menuObj[parentPath] || []), ...(menuObj[currentPath] || [])].length">{{ path.title }}</span>
        <span class="title" v-else>{{ path.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    currentPath: vm => vm.$route.path,
    parentPath: vm => (vm.$route.path.includes(vm.$route.query.parentPath) ? '' : vm.$route.query.parentPath),
    menuObj: vm => vm.$store.state.menuObj || {}
  },
  methods: {}
};
</script>

<style lang="scss">
.tab-path {
  line-height: 16px;
  height: 50px;
  padding: 17px 0;
  color: #6c757d;
  display: flex;
  .path {
    font-size: 12px;
    .gap {
      color: #adb5bd;
      margin: 0 6px;
    }
    .title {
      color: #adb5bd;
      &.link {
        cursor: pointer;
      }
    }
    & > div:last-child .title {
      color: #6c757d;
    }
  }
}
</style>
